module.exports = __webpack_public_path__ + "static/media/faq-video-captions-en.908899ab.vtt";